import { useState } from 'react';

const C = {
  bg: '#070B10', surface: '#0D1520', border: '#1A2A40',
  accent: '#00D4FF', text: '#E8F0F8', muted: '#5A7A99',
  green: '#00E5A0', yellow: '#FFD166',
  mono: "'JetBrains Mono','Fira Mono',monospace",
  sans: "'Inter',system-ui,sans-serif",
};

export default function ReconstitutionTab() {
  const [vialMg, setVialMg] = useState('');
  const [waterMl, setWaterMl] = useState('');
  const [targetDose, setTargetDose] = useState('');
  const [doseUnit, setDoseUnit] = useState('mcg');

  const calculate = () => {
    const vial = parseFloat(vialMg);
    const water = parseFloat(waterMl);
    const dose = parseFloat(targetDose);

    if (!vial || !water || !dose) return null;

    // Convert vial to mcg (vial is in mg)
    const vialMcg = vial * 1000;
    
    // Convert target dose to mcg
    const doseMcg = doseUnit === 'mg' ? dose * 1000 : dose;

    // Concentration = total peptide / water volume
    const concentrationMcgMl = vialMcg / water;

    // Draw volume = target dose / concentration
    const drawVolumeMl = doseMcg / concentrationMcgMl;

    // Syringe units (U-100 = 100 units per mL)
    const units = drawVolumeMl * 100;

    return {
      concentrationMcgMl,
      drawVolumeMl,
      units,
    };
  };

  const result = calculate();

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      {/* Input Section */}
      <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 8, padding: 20 }}>
        <div style={{ fontFamily: C.mono, fontSize: 12, color: C.muted, letterSpacing: '0.1em', marginBottom: 20, fontWeight: 600 }}>RECONSTITUTION CALCULATOR</div>
        
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 20 }}>
          <div>
            <label style={{ display: 'block', fontSize: 11, color: C.muted, fontFamily: C.mono, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Vial Size (mg)</label>
            <input 
              type="number" 
              value={vialMg} 
              onChange={e => setVialMg(e.target.value)} 
              placeholder="10"
              step="0.1"
              style={{ width: '100%', padding: '12px', background: C.bg, border: `1px solid ${C.border}`, borderRadius: 6, color: C.text, fontFamily: C.sans, fontSize: 14 }} 
            />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 11, color: C.muted, fontFamily: C.mono, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Bac Water (mL)</label>
            <input 
              type="number" 
              value={waterMl} 
              onChange={e => setWaterMl(e.target.value)} 
              placeholder="1"
              step="0.1"
              style={{ width: '100%', padding: '12px', background: C.bg, border: `1px solid ${C.border}`, borderRadius: 6, color: C.text, fontFamily: C.sans, fontSize: 14 }} 
            />
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 16 }}>
          <div>
            <label style={{ display: 'block', fontSize: 11, color: C.muted, fontFamily: C.mono, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Target Dose</label>
            <input 
              type="number" 
              value={targetDose} 
              onChange={e => setTargetDose(e.target.value)} 
              placeholder="250"
              step="0.1"
              style={{ width: '100%', padding: '12px', background: C.bg, border: `1px solid ${C.border}`, borderRadius: 6, color: C.text, fontFamily: C.sans, fontSize: 14 }} 
            />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: 11, color: C.muted, fontFamily: C.mono, marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Unit</label>
            <select 
              value={doseUnit} 
              onChange={e => setDoseUnit(e.target.value)} 
              style={{ width: '100%', padding: '12px', background: C.bg, border: `1px solid ${C.border}`, borderRadius: 6, color: C.text, fontFamily: C.sans, fontSize: 14 }}
            >
              <option value="mcg">mcg</option>
              <option value="mg">mg</option>
            </select>
          </div>
        </div>
      </div>

      {/* Results Section */}
     {result && (
  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
    <div style={{ background: C.surface, border: `2px solid ${C.accent}`, borderRadius: 8, padding: 20, textAlign: 'center' }}>
      <div style={{ fontSize: 10, color: C.muted, fontFamily: C.mono, marginBottom: 12, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Concentration</div>
      <div style={{ fontSize: 28, fontWeight: 700, color: C.accent, fontFamily: C.mono, marginBottom: 4 }}>{(result.concentrationMcgMl / 1000).toFixed(2)}</div>
      <div style={{ fontSize: 11, color: C.muted, fontFamily: C.mono }}>mg/mL</div>
    </div>

    <div style={{ background: C.surface, border: `2px solid ${C.green}`, borderRadius: 8, padding: 20, textAlign: 'center' }}>
      <div style={{ fontSize: 10, color: C.muted, fontFamily: C.mono, marginBottom: 12, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Draw Volume</div>
      <div style={{ fontSize: 28, fontWeight: 700, color: C.green, fontFamily: C.mono, marginBottom: 4 }}>{result.drawVolumeMl.toFixed(3)}</div>
      <div style={{ fontSize: 11, color: C.muted, fontFamily: C.mono }}>mL</div>
    </div>

    <div style={{ background: C.surface, border: `2px solid ${C.yellow}`, borderRadius: 8, padding: 20, textAlign: 'center' }}>
      <div style={{ fontSize: 10, color: C.muted, fontFamily: C.mono, marginBottom: 12, textTransform: 'uppercase', letterSpacing: '0.08em' }}>Syringe Units</div>
      <div style={{ fontSize: 28, fontWeight: 700, color: C.yellow, fontFamily: C.mono, marginBottom: 4 }}>{result.units.toFixed(0)}</div>
      <div style={{ fontSize: 11, color: C.muted, fontFamily: C.mono }}>U-100</div>
    </div>
  </div>
)}

      {/* Info */}
      <div style={{ background: C.surface, border: `1px solid ${C.border}`, borderRadius: 8, padding: 16, fontSize: 12, color: C.muted, fontFamily: C.mono, lineHeight: 1.8 }}>
        <div style={{ fontWeight: 600, color: C.accent, marginBottom: 12 }}>Example: 10mg vial + 1mL water + 1mg dose</div>
        <div>• Concentration: 10,000 mcg/mL</div>
        <div>• Draw Volume: 0.1 mL</div>
        <div>• Syringe Units: 10 units</div>
      </div>
    </div>
  );
}